import type { ReactNode } from "react";
import { Box, Paper, Typography } from "@mui/material";

type Props = {
  icon?: ReactNode;
  title: string;
  children: ReactNode;
};

export function SectionCard({ icon, title, children }: Props) {
  return (
    <Box sx={{ mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          mb: 1,
          color: "primary.main",
        }}
      >
        {icon}
        <Typography sx={{ fontSize: 15, fontWeight: 700 }}>{title}</Typography>
      </Box>
      <Paper
        variant="outlined"
        sx={{
          borderColor: "#E0E4EF",
          borderRadius: "8px",
          overflow: "hidden",
          px: 1.5,
        }}
      >
        {children}
      </Paper>
    </Box>
  );
}

export default SectionCard;
